import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.5 2.75A3.25 3.25 0 0 0 2.25 6v12a3.25 3.25 0 0 0 3.25 3.25h4.25V2.75zM.75 6A4.75 4.75 0 0 1 5.5 1.25h5.75v21.5H5.5A4.75 4.75 0 0 1 .75 18zm7.5 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0M18.5 1.25h-5.75v21.5h5.75A4.75 4.75 0 0 0 23.25 18V6a4.75 4.75 0 0 0-4.75-4.75M20 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandGamingNintendoSwitch = { render };
export {
  brandGamingNintendoSwitch as default,
  render
};
//# sourceMappingURL=brand-gaming-nintendo-switch.svg.js.map
